import type { ButtonHTMLAttributes } from "react";
import styles from "./Button.module.css";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & { tone?: "default" | "primary" | "danger"; size?: "normal" | "big" };

export function Button({ tone = "default", size = "normal", className, type = "button", ...rest }: Props) {
  return <button type={type} className={[styles.btn, styles[tone], styles[size], className].filter(Boolean).join(" ")} {...rest} />;
}
